module.exports = __webpack_public_path__ + "img/navigazione-internet-new(3).cba6b361.png";